import React, { useRef, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  formStartEvent,
  formIntermediateEvent,
  formSuccessEvent,
  formSubmissionFailEvent,
  formAbandonmentEvent,
  formFieldErrorEvent,
  ctaClickEvent,
} from "../services/adobeDataLayer.js";
import {
  formatAndValidateE164,
  hashValue,
  setValuesInLocalStorange,
} from "../services/utils.js";

import { useCookies } from "react-cookie";
import queryString from "query-string";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

// import ReCAPTCHA from "react-google-recaptcha";
import {
  callLSQLapp,
  getLsqLeadBody,
  checkEligibility,
  encryptBody,
} from "../services/lsq.js";
function FormComponent() {
  const navigate = useNavigate();
  let cancelToken;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    trigger,
    control,
    setFocus,
    setError,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({
    mode: "onBlur",
  });


  const [email, setEmail] = useState("");
  const [isEmailEmpty, setIsEmailEmpty] = useState();
  const [showSendOtp, setShowSendOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);
  const [token, setToken] = useState("");
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [utmDetails, setUtmDetails] = useState({});
  const [showOtherCompany, setShowOtherCompany] = useState(false);
  const [company, setCompany] = useState("");
  const [companyName, setCompanyName] = useState("");
  // const [topCorporate, settopCorporate] = useState("");
  const [companies, setCompanies] = useState([]);
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [hasAbandoned, setHasAbandoned] = useState(false);
  const [otpSentCount, setOtpSentCount] = useState(0);
  const [showCountryCode, setShowCountryCode] = useState(false);
  const [institutes, setInstitutes] = useState([]);
  const [instituteMap, setInstituteMap] = useState({});
  const [collegeCategory, setCollegeCategory] = useState("");

  const [filteredInstitutes, setFilteredInstitutes] = useState(institutes);
  const [showList, setShowList] = useState(false);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);

  const mobileValue = watch("mobile");
  const employmentType = watch("employmentType");
  const hasITR = watch("hasITR");
  // const companyName = watch("companyName");
  const annualIncome = watch("annualIncome");
  const instituteName = watch("InstituteName");
  const topCorporate = watch("topCorporate");

  const companyWrapperRef = useRef(null);
  const firstOtpSentTimeRef = useRef(null);
  const inputWrapperRef = useRef(null);
  const hasTriggeredFormStart = useRef(false);
  const lastAccessedFieldRef = useRef("");
  const hasFetched = useRef(false);

  const institutesLower = institutes.map((i) => i.toLowerCase());

  const isOthersSelected =
    instituteName &&
    (instituteName.toUpperCase() === "OTHERS" ||
      !institutes.some(
        (name) => name.toUpperCase() === instituteName.toUpperCase()
      ));

  function showToast(type, message) {
    const toast = document.createElement("div");
    toast.className = `toast ${type}`;
    toast.textContent = message;

    document.getElementById("toastContainer").appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 4000); // Auto-dismiss after 4 seconds
  }

  // Institute Dropdown
  const handleInput = (e) => {
    handleChange(e);
    const value = e.target.value;

    if (!value.trim()) {
      setFilteredInstitutes(institutes);
      setShowList(true);
      return;
    }

    let results = institutes.filter((name) =>
      name.toLowerCase().includes(value.toLowerCase())
    );

    if (results.length === 0) {
      results = ["Others"];
    }

    setFilteredInstitutes(results);
    setShowList(true);
  };

  const handleFocus = () => {
    handleFieldFocus("InstituteName");
    setFilteredInstitutes(institutes);
    setShowList(true);
  };

  const fetchAllInstitutes = async () => {
    try {
      const param = { type: "eliteAlumini" };
      const response = await callLSQLapp({}, "ALUMINI", param);

      if (response?.data?.message?.Data) {
        const data = response.data.message.Data;

        const instituteNames = [];
        const instituteCategoryMap = {};

        data.forEach((item) => {
          instituteNames.push(item.Institute_Name);
          instituteCategoryMap[item.Institute_Name] = item.College_Category;
        });

        console.log(instituteCategoryMap);

        setInstitutes(instituteNames);
        setFilteredInstitutes(instituteNames);
        setInstituteMap(instituteCategoryMap);
        localStorage.setItem(
          "allInstitutes",
          JSON.stringify({
            instituteNames,
            instituteCategoryMap,
          })
        );
      }
    } catch (error) {
      console.error(error);

      const cached = localStorage.getItem("allInstitutes");
      if (cached) {
        const parsed = JSON.parse(cached);
        setInstitutes(parsed.instituteNames);
        setFilteredInstitutes(parsed.instituteNames);
        setInstituteMap(parsed.instituteCategoryMap);
      }
    }
  };

  const handleInstituteSelect = (name) => {
    setValue("InstituteName", name);
    setCollegeCategory(instituteMap[name] || "");

    setShowList(false);
  };

  // YOP
  const years = Array.from({ length: 2025 - 1980 + 1 }, (_, i) =>
    (1980 + i).toString()
  );

  const [filteredYears, setFilteredYears] = useState(years);
  const [showList1, setShowList1] = useState(false);

  const handleInput1 = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // allow only digits

    e.target.value = value;
    handleChange(e);

    // Filter list based on input
    const results = years.filter((year) => year.includes(value));
    setFilteredYears(results);
    setShowList1(true);
  };

  const handleFocus1 = () => {
    console.log(collegeCategory);
    handleFieldFocus("YearPassing");
    setFilteredYears(years); // show full list
    setShowList1(true);
  };

  const handleSelect1 = (year) => {
    const input = document.getElementById("YearPassing");
    input.value = year;
    setValue("YearPassing", year, { shouldValidate: true });
    setShowList1(false);
  };

  const handleBlur1 = () => {
    setTimeout(() => setShowList1(false), 150);
  };

  //Last Accessed Field
  useEffect(() => {
    const resetAccessField = () => {
      lastAccessedFieldRef.current = "";
    };
    window.addEventListener("beforeunload", resetAccessField);
    return () => window.removeEventListener("beforeunload", resetAccessField);
  }, []);

  // React event for input fields
  const handleChange = async (e) => {
    const fieldName = e.target.name || "unknown";
    lastAccessedFieldRef.current = fieldName;
    if (!hasTriggeredFormStart.current) {
      formStartEvent("topinstitute lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    setHasAbandoned(false);
  };

  useEffect(() => {
    if (otp.length === 6) {
      handleVerifyOtp();
    }
  }, [otp]);

  useEffect(() => {
    if (!hasFetched.current) {
      fetchAllInstitutes();
      hasFetched.current = true;
    }
  }, []);

  useEffect(() => {
    setFocus("firstName");
  }, [setFocus]);

  useEffect(() => {
    // Institute = Others → reset salaried-specific fields
    if (instituteName === "Others") {
      setValue("companyName", "");
      setCompanyName("");
      setCompanies([]);
      setValue("annualIncome", "");
      setValue("lastYearIncome", "");
      setValue("hasITR", "");
      setValue("CardType", "");
      setValue("collegeCategory", "");

      // settopCorporate("");
      setValue("topCorporate", "");
      // return;
    }

    if (instituteName !== "Others") {
      setValue("companyName", "");
      setCompanyName("");
      setCompanies([]);
      setValue("annualIncome", "");
      setValue("lastYearIncome", "");
      setValue("hasITR", "");
      setValue("CardType", "");
      setValue("collegeCategory", "");
      setValue("employmentType", "");

      // settopCorporate("");
      setValue("topCorporate", "");
      return;
    }
    // Reset salaried fields ONLY if user switches away from salaried
    if (employmentType && employmentType !== "salaried") {
      setValue("companyName", "");
      setCompanyName("");
      setCompanies([]);
      setValue("annualIncome", "");
      setValue("YearPassing", "");

      // settopCorporate("");
      setValue("topCorporate", "");
      setValue("CardType", "");
    }

    // Reset self-employed fields ONLY if user switches away
    if (employmentType && employmentType !== "self-employed") {
      setValue("lastYearIncome", "");
      setValue("hasITR", "");
      setValue("YearPassing", "");
    }
  }, [employmentType, instituteName, setValue]);

  // Outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      const wrapper = inputWrapperRef.current;
      if (!wrapper) return;

      if (
        !wrapper.contains(event.target) &&
        hasTriggeredFormStart.current &&
        !hasAbandoned
      ) {
        formAbandonmentEvent(
          "topinstitute lead form",
          "lead generation",
          lastAccessedFieldRef.current,
          "details"
        );
        setHasAbandoned(true);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [hasAbandoned]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     const wrapper = inputWrapperRef.current;

  //     console.log("wrapper",wrapper)
  //     console.log("!wrapper.contains(event.target)",!wrapper.contains(event.target))
  //      console.log("hasTriggeredFormStart.current",hasTriggeredFormStart.current)
  //      console.log("!hasAbandoned",!hasAbandoned)
  //     if (
  //       wrapper &&
  //       !wrapper.contains(event.target) &&
  //       hasTriggeredFormStart.current &&
  //       !hasAbandoned
  //     ) {
  //       const lastField = lastAccessedFieldRef.current;
  //       formAbandonmentEvent(
  //         "topinstitute lead form",
  //         "lead generation",
  //         lastField,
  //         "details"
  //       );
  //       setHasAbandoned(true);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [hasAbandoned]);

  // set Fbp, Fbc, UTM parameters values
  useEffect(() => {
    let retryCount = 0; // Initialize retry counter
    const maxRetries = 5; // Maximum number of retries
    const retryInterval = 3000; // Retry interval in milliseconds

    const fetchCookies = () => {
      const getCookieValue = (cookieName) => {
        return document.cookie
          .split("; ")
          .find((row) => row.startsWith(cookieName))
          ?.split("=")[1] || "";
      };

      const fbpValue = getCookieValue("_fbp");
      const fbcValue = getCookieValue("_fbc");

      // Update state if values are found
      if (fbpValue) setFbp(fbpValue);
      if (fbcValue) setFbc(fbcValue);

      // Retry logic
      if ((!fbpValue || !fbcValue) && retryCount < maxRetries) {
        retryCount++;
        setTimeout(fetchCookies, retryInterval);
      }
    };

    fetchCookies();

    // set UTM parameters
    const getUTMDetails = queryString.parse(window.location.search);

    setUtmDetails(getUTMDetails);
  }, []);

  //OTP Button
  useEffect(() => {
    if (/^\d{10}$/.test(mobileValue)) {
      setShowSendOtp(true);
    } else {
      setShowSendOtp(false);
    }
  }, [mobileValue]);

  // Timer countdown
  useEffect(() => {
    if (otpSent && timer > 0 && !otpVerified) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, timer, otpVerified]);

  //to handle form error events
  useEffect(() => {
    const handleErrorEvent = (e) => {
      if (hasTriggeredFormStart.current) {
        handleFormFieldErrorEvent(e.detail);
      }
    };
    window.addEventListener("formErrorEvent", handleErrorEvent);
    return () => {
      window.removeEventListener("formErrorEvent", handleErrorEvent);
    };
  }, []);

  const handleFormFieldErrorEvent = (errorData) => {
    formFieldErrorEvent(errorData);
  };

  function triggerFormErrorEvent(errors) {
    const flatErrors = {};

    Object.keys(errors).forEach((key) => {
      if (errors[key]?.message) {
        flatErrors[key] = errors[key].message;
      }
    });

    if (Object.keys(flatErrors).length === 0) return; // no error, no event

    const event = new CustomEvent("formErrorEvent", {
      detail: flatErrors,
    });

    window.dispatchEvent(event);
  }

  const onError = async (errors) => {
    if (!hasTriggeredFormStart.current) {
      await formStartEvent(
        "topinstitute lead form",
        "lead generation",
        "details"
      );

      hasTriggeredFormStart.current = true;
    }

    triggerFormErrorEvent(errors);
  };

  const handleFieldFocus = (fieldName) => {
    lastAccessedFieldRef.current = fieldName;
  };

  const OTP_LIMIT = 3;
  const OTP_WINDOW = 10 * 60 * 1000;

  const handleSendOtp = async (source) => {
    if (!mobileValue) return;
    if (mobileValue.length !== 10) return;

    const now = Date.now();

    // Reset window if 10 mins passed since first OTP sent
    if (
      !firstOtpSentTimeRef.current ||
      now - firstOtpSentTimeRef.current > OTP_WINDOW
    ) {
      firstOtpSentTimeRef.current = now;
      setOtpSentCount(0);
    }

    if (otpSentCount >= OTP_LIMIT) {
      showToast(
        "error",
        "You have reached the maximum of 3 OTP sends within 10 minutes."
      );
      return;
    }

    try {
      let payload = { mobile: mobileValue, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "CC" };
      const res = await callLSQLapp(payload, "OTP", param);

      if (res.data.message.response.sent) {
        // Update count after successful send
        setOtpSentCount((count) => count + 1);

        // Trigger analytics events
        if (source === "resend") {
          ctaClickEvent("otp:resend", "lead form", "button", 0, "na");
        } else {
          formIntermediateEvent("send", "otp");
        }

        showToast("success", "An OTP has been sent to your Mobile number.");
        setOtpVerified(false);
        setTimer(60);
        setOtpSent(true);
      }
    } catch (error) {
      showToast("error", "Error occurred while generating OTP.");
    }
  };

  const handleVerifyOtp = async () => {
    if (!mobileValue) {
      showToast("error", "Please enter mobile number");
      //alert("Please enter mobile number");
      return;
    }
    if (otp.length === 6) {
      try {
        // const res = await onVerifyOtp(mobileValue, otp);
        // if (res.data.message === "Failure Occured, please check logs") {

        let payload = { mobile: mobileValue, otp: otp };
        let param = { otp: "verify", productType: "CC" };
        const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
        if (
          otpVerifyResponse.data.message ===
          "Failure Occured, please check logs"
        ) {
          showToast("error", "Incorrect OTP");
          let errorFields = {
            otp: "Incorrect OTP",
          };
          formFieldErrorEvent(errorFields);
          //alert("Please enter valid OTP");
        } else {
          setOtpVerified(true);
          setTimer(0);
          formIntermediateEvent("verified", "otp");
          showToast("success", "OTP verified.");
          const tokenValue =
            otpVerifyResponse.data.message.response.dataSent.UniqueID;
          setToken(tokenValue);
        }
      } catch (error) {
        showToast("error", "Error verifying OTP.");
        //alert("Error verifying OTP.");
      }
    }
  };

  let lastFetchedPrefix = ""; // Keep this at module or component level
  const STORAGE_KEY = "eliteCompany_";

  const setToStorage = (key, data) => {
    localStorage.setItem(
      key,
      JSON.stringify({
        data,
        timestamp: Date.now(),
      })
    );
  };

  const getFromStorage = (key, ttl = 24 * 60 * 60 * 1000) => {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.timestamp > ttl) {
        localStorage.removeItem(key);
        return null;
      }
      return parsed.data;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  };

  const filterAndAppendOthers = (list, inputValue) => {
    const filtered = list.filter((item) =>
      item.Entity_Name.toLowerCase().startsWith(inputValue.toLowerCase())
    );

    const hasExactMatch = filtered.some(
      (item) => item.Entity_Name.toLowerCase() === inputValue.toLowerCase()
    );

    if (!hasExactMatch && inputValue.length > 0) {
      filtered.push({ Entity_Name: "Others", LTF: null });
    }

    return filtered;
  };

  const onCompanyChange = async (e) => {
    const inputValue = e.target.value.trim();
    setCompany(inputValue);

    if (inputValue.length < 2) {
      setCompanies([]);
      return;
    }

    const prefix = inputValue.substring(0, 4).toLowerCase();
    const storageKey = `${STORAGE_KEY}${prefix}`;

    // 1. Try localStorage first
    const cachedData = getFromStorage(storageKey);
    if (cachedData) {
      setCompanies(filterAndAppendOthers(cachedData, inputValue));
      return;
    }

    // 2. Avoid duplicate API calls
    if (prefix === lastFetchedPrefix) return;

    lastFetchedPrefix = prefix;

    if (cancelToken) {
      cancelToken.cancel("Cancelled due to new request");
    }

    cancelToken = axios.CancelToken.source();

    try {
      const payload = { company: inputValue };
      const param = { type: "eliteCompany" };

      const response = await callLSQLapp(payload, "MAVIS", param);
      const { Data = [], Count = 0 } = response.data.message || {};

      if (Count > 0) {
        setToStorage(storageKey, Data);
        setCompanies(filterAndAppendOthers(Data, inputValue));
      } else {
        setCompanies([{ Entity_Name: "Others", LTF: null }]);
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error("Company fetch failed:", error);
      }
    }
  };

  const handleReset = () => {
    if (hasTriggeredFormStart.current) {
      ctaClickEvent("Reset", "lead form", "button", 0, "na");
    }

    reset();
    setOtp("");
    setOtpSent(false);
    setOtpVerified(false);
    setTimer(60);
    setShowSendOtp(false);
    setCompanyName("");
    setEmail("");
  };

  async function Tandc() {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("topinstitute lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    if (hasTriggeredFormStart.current) {
      ctaClickEvent(
        "Terms & Conditions",
        "lead form",
        "text link",
        0,
        "https://www.icicibank.com/terms-condition/credit-card-terms-and-conditions.page"
      );
    }
  }

  async function MITandC() {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("topinstitute lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    if (hasTriggeredFormStart.current) {
      ctaClickEvent(
        "Most Important Terms & Conditions",
        "lead form",
        "text link",
        0,
        "https://www.icicibank.com/managed-assets/docs/personal/cards/MITC_cc.pdf"
      );
    }
  }

  const onSubmit = async (data) => {
    if (mobileValue.length === 10) {
      let errorMessage = "";

      if (!otpSent) {
        errorMessage = "Click on Send OTP to continue";
      } else if (!otp) {
        errorMessage = "Please enter OTP to continue";
      } else if (!otpVerified) {
        errorMessage = "Please verify OTP to continue";
      }
      if (errorMessage) {
        const errorFields = {
          otp: errorMessage,
        };
        formFieldErrorEvent(errorFields);
        showToast("error", errorMessage);
        return;
      }
    }
    //     if (!otpSent && mobileValue.length == 10) {
    //       let errorFields = {
    //         otpError: "Click on Send OTP to continue",
    //       };
    //       formFieldErrorEvent(errorFields);
    //       showToast("error", "Click on Send OTP to continue.");
    //       //alert("Click on Sent OTP to continue.");
    //       return;
    //     } else if (!otp) {
    //           let errorFields = {
    //   otpError: "Please enter OTP to continue",
    // };
    //       formFieldErrorEvent(errorFields);
    //       showToast("error", "Please enter OTP to continue.");
    //       //alert("Please enter OTP to continue.");
    //       return;
    //     } else if (!otpVerified) {
    //        let errorFields = {
    //   otpError: "Please verify OTP to continue",
    //     };
    //       formFieldErrorEvent(errorFields);
    //       showToast("error", "Please verify OTP to continue.");
    //       //alert("Please verify OTP to continue.");
    //       return;
    //     }

    if (otpVerified) {
      setApplyBtnDisable(true);
    }

    data.token = token;
    data.Product = "creditcards";
    data.ModeOfLead = "landing-page";
    data.CampaignId = "819038";
    data.CompleteUrl = window.location.href;
    data.FBPixelID = fbp;
    data.FBClickID = fbc;
    data.IsAuthorized = "Yes";
    data.pageType = "topinstitute"; //unique Identifier
    data.User_Agent = navigator.userAgent;
    data.otp = otp;
    data.topCorporate = topCorporate;
    data.collegeCategory = collegeCategory;
    data.typeOfLead = "";
    data.Eligible = "";
    data.CardType = "";
    data.IpCollegeName = "NA"
    /*  College Category */
    if (collegeCategory) {
      const collegeCardMap = {
        A: "ICICI Bank Sapphiro Credit Card",
        B: "ICICI Bank Rubyx Credit Card",
        C: "ICICI Bank Coral Credit Card",
      };

      data.CardType = collegeCardMap[collegeCategory] || "";
      data.Eligible = "Yes";
      data.typeOfLead = "Alumni";
      data.IPCustomerCategory = "Alumni";
      data.IpCardName = collegeCardMap[collegeCategory] || "";
      data.IpCompanyName = "NA";
      data.IpCollegeName = data.InstituteName;
    } else if (data.employmentType === "salaried") {
      /* Salaried */
      const salariedTopCorporateMap = {
        "below 2,40,000": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "2,40,000 - 5,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "6,00,000 - 8,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "9,00,000 - 17,99,999": {
          CardType: "ICICI Bank Rubyx Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "18,00,000 - 47,99,999": {
          CardType: "ICICI Bank Sapphiro Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "48,00,000 - 2,49,99,999": {
          CardType: "ICICI Bank Sapphiro Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "2,50,00,000 and above": {
          CardType: "ICICI Bank Emerald Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
      };

      const salariedNonTopCorporateMap = {
        "below 2,40,000": {
          CardType: "",
          Eligible: "No",
          typeOfLead: "Preferred Corporate",
        },
        "2,40,000 - 5,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "6,00,000 - 8,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "9,00,000 - 17,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "18,00,000 - 47,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "48,00,000 - 2,49,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "2,50,00,000 and above": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
      };

      const salariedOtherCorporateMap = {
        "below 2,40,000": {
          CardType: "",
          Eligible: "No",
          typeOfLead: "Others",
        },
        "2,40,000 - 5,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "6,00,000 - 8,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "9,00,000 - 17,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "18,00,000 - 47,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "48,00,000 - 2,49,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "2,50,00,000 and above": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
      };

      // const incomeMap = topCorporate === "yes"
      //     ? salariedTopCorporateMap
      //     : salariedNonTopCorporateMap;
      let incomeMap;

      if (topCorporate === "yes") {
        incomeMap = salariedTopCorporateMap;
      } else if (topCorporate === "others") {
        incomeMap = salariedOtherCorporateMap;
      } else {
        incomeMap = salariedNonTopCorporateMap;
      }

      const result = incomeMap[data.annualIncome];
      if (result) {
        data.CardType = result.CardType;
        data.Eligible = result.Eligible;
        data.typeOfLead = result.typeOfLead;

        data.IPCustomerCategory = result.typeOfLead;
        data.IpCardName = result.CardType;
        data.IpCompanyName = data.companyName;
      }
    } else if (data.employmentType === "self-employed") {
      /* Self-employed */
      if (data.hasITR === "no") {
        data.Eligible = "No";
        data.typeOfLead = "SES";
        data.CardType = "";
        data.IPCustomerCategory = "Not Eligible"
        data.IpCardName = "Not Eligible";
        data.IpCompanyName = "Not Eligible";
        data.IpCollegeName = "Not Eligible"
      } else {
        const income = Number(data.lastYearIncome);
        if (income < 240000) {
          data.Eligible = "No";
          data.typeOfLead = "SES";
          data.IPCustomerCategory = "Not Eligible"
          data.IpCardName = "Not Eligible";
          data.IpCompanyName = "Not Eligible";
          data.IpCollegeName = "Not Eligible"
        } else if (income < 1800000) {
          data.CardType = "ICICI Bank Platinum Chip Credit Card";
          data.Eligible = "Yes";
          data.typeOfLead = "SES";
          data.IPCustomerCategory = "SES"
          data.IpCardName = "ICICI Bank Platinum Chip Credit Card";
          data.IpCompanyName = "NA";
          data.IpCollegeName = "NA";

        } else {
          data.CardType = "ICICI Bank Coral Credit Card";
          data.Eligible = "Yes";
          data.typeOfLead = "SES";
          data.IPCustomerCategory = "SES"
          data.IpCardName = "ICICI Bank Coral Credit Card";
          data.IpCompanyName = "NA";
          data.IpCollegeName = "NA"
        }
      }
    }


    if (data.mobile) {
      const formattedMobile = formatAndValidateE164(data.mobile);
      const hashedMobile = await hashValue(formattedMobile);
      data.hashedMobile = hashedMobile
      setValuesInLocalStorange("userData", hashedMobile);
      console.log(localStorage.getItem("userData"), "userData");
    }


    if (data.Eligible === "No") {
      data.IPCustomerCategory = "Not Eligible"
      data.IpCardName = "Not Eligible";
      data.IpCompanyName = "Not Eligible";
      data.IpCollegeName = "Not Eligible"
    }

    // get utm parameteres values
    const utmParamsObj = queryString.parse(window.location.search);
    // console.log(utmParamsObj);
    for (const [key, value] of Object.entries(utmParamsObj)) {
      // console.log("key", { key: value });
      data[key] = value;
    }

    localStorage.setItem("data", JSON.stringify(data));
    const formData1 = JSON.parse(localStorage.getItem("data"));
    const mergedObject = { ...formData1, ...data };

    console.log(data);
    let payload = {
      mobile: data.mobile,
      otp: data.otp,
      formdata: getLsqLeadBody(data),
    };

    let param = { productType: "CC" };

    console.log("pay", payload);
    const encryptedPayload = await encryptBody(payload);
    let createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
    if (createLeadResp.data.message !== "Failure occured , please check logs") {
      let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
      console.log("leadID", leadid);

      const isSalaried = data.employmentType === "salaried";


      // Prepare event payload
      let AdobeEventPayload = {};

      if (data.typeOfLead === "Alumni") {
        AdobeEventPayload = {
          institute: data.InstituteName,
          yop: data.YearPassing,
        };
      } else if (isSalaried) {
        AdobeEventPayload = {
          employmentType: data.employmentType,
          company: data.companyName,
          annualIncome: data.annualIncome,
        };
      } else {
        AdobeEventPayload = {
          employmentType: data.employmentType,
          income: data.lastYearIncome,
          ITRStatus: hasITR,
        };
      }

      // Call form success event
      formSuccessEvent(
        "topinstitute lead form",
        AdobeEventPayload,
        "lead generation",
        "thank you",
        true
      );

      // Set localStorage type based on eligibility and employmentType

      // 1 - Not eligible (salaried and low income, self employed and low income, self employed with high income but no ITR)
      // 2 - eligible but self employed, not salaried
      // 3 - eligible and salaried
      if (data.Eligible === "Yes") {
        localStorage.setItem("type", isSalaried ? 3 : 2);
        // localStorage.setItem("type", 3);
      } else {
        localStorage.setItem("type", 1);
      }

      // Navigate to thank you page
      navigate(`/thankyou?id=${leadid}`);
    } else {
      formSubmissionFailEvent();
      setApplyBtnDisable(false);
      showToast("error", "Error Occured, Please try again after sometime");
    }
    // let type;
    // // if (hasEmp) {
    // //   type = (isSalaried && isSalariedAndLowIncome) || isSalariedAndLowIncome || isSelfEmployed ? 1 : 3;
    // // } else {
    // //   type = 3;
    // // }

    //    if (data.Eligible === "Yes") {
    //     type = isSalaried ? 3 : 2;
    // } else {
    //   type = 1;
    // }
    // if (data.Eligible === "Yes" || isSalaried) {
    //   //alert("ata.Eligible" + type);
    //   localStorage.setItem("type", type);
    // } else {
    //   //alert("not.Eligible");
    //   localStorage.setItem("type", 1);
    // }

    // console.log("Type :", type);

    // navigate("/thankyou");
  };

  return (
    <form
      ref={inputWrapperRef}
      onSubmit={handleSubmit(onSubmit, onError)}
      id="myForm"
      className="myForm"
    >
      <h3>Fill the form below</h3>
      <div className="px-3">
        {/* Full Name */}
        <div className="d-md-flex gap-2 name-wrap">
          <div className="input_wrapper">
            <input
              type="text"
              id="firstName"
              placeholder="First Name"
              className="mt-0"
              disabled={otpVerified}
              onFocus={() => handleFieldFocus("firstName")}
              {...register("firstName", {
                required: "First name is required",
                pattern: {
                  value: /^[a-zA-Z\s]+$/,
                  message: "Only alphabets and spaces allowed",
                },
              })}
              onInput={(e) => {
                handleChange(e);
                e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              }}
            />

            {errors.firstName && (
              <span className="error">{errors.firstName.message}</span>
            )}
          </div>
          <div className="input_wrapper">
            <input
              type="text"
              id="name"
              placeholder="Last Name"
              disabled={otpVerified}
              onFocus={() => handleFieldFocus("lastName")}
              {...register("lastName", {
                required: "Last name is required",
                pattern: {
                  value: /^[a-zA-Z\s]+$/,
                  message: "Only alphabets and spaces allowed",
                },
              })}
              onInput={(e) => {
                handleChange(e);
                e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              }}
            />
            {errors.lastName && (
              <span className="error">{errors.lastName.message}</span>
            )}
          </div>
        </div>
        <p className="label">Name (As per PAN)</p>

        {/* Mobile Number */}
        <div className=" otp_wrapper input_wrapper">
          <div className="d-flex align-items-center gap-2 ">
            <div
              className={`mobile-wrapper ${showCountryCode ? "with-code" : ""}`}
            >
              {showCountryCode && <span className="country-code">+91</span>}

              <input
                type="text"
                id="mobile"
                placeholder="Mobile Number"
                disabled={otpVerified}
                inputMode="numeric"
                maxLength={10}
                {...register("mobile", {
                  required: "Mobile number is required",
                  pattern: {
                    value: /^[6-9][0-9]{9}$/,
                    message: "Enter a valid number",
                  },
                })}
                onFocus={() => handleFieldFocus("Mobile")}
                onInput={(e) => {
                  handleChange(e);

                  let value = e.target.value.replace(/\D/g, "");

                  // show +91 as soon as user types first digit
                  setShowCountryCode(value.length >= 1);

                  // validate ONLY based on first digit
                  if (value.length >= 1 && /^[1-5]/.test(value)) {
                    setError("mobile", {
                      type: "manual",
                      message: "Enter a valid number",
                    });
                  } else {
                    clearErrors("mobile");
                  }

                  e.target.value = value;
                }}
              />
            </div>

            <div className="input_wrapper">
              {otpVerified ? (
                <button
                  type="button"
                  className="resend otp-verified"
                  id=""
                  disabled
                >
                  OTP Verified
                </button>
              ) : (
                !otpSent &&
                !otpVerified && (
                  <button
                    type="button"
                    className="resend"
                    id="sendOtpBtn"
                    onClick={() => handleSendOtp("send")}
                  >
                    Send OTP
                  </button>
                )
              )}
            </div>
          </div>
          {errors.mobile && (
            <span className="error">{errors.mobile.message}</span>
          )}
        </div>

        {/* OTP Field */}
        {otpSent && !otpVerified && (
          <div className="otp_wrapper input_wrapper">
            <div className="d-flex align-items-center gap-2 ">
              <input
                type="text"
                id="otp"
                onFocus={() => handleFieldFocus("otp")}
                placeholder="Enter the OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
                inputMode="numeric"
              />
              <span className="timer">
                {timer < 10 ? `00:0${timer}` : `00:${timer}`}
              </span>
              {timer <= 0 && (
                <button
                  type="button"
                  className="resend"
                  id="resendBtn"
                  onClick={() => handleSendOtp("resend")}
                >
                  Resend
                </button>
              )}
            </div>
            {errors.otp && <span className="error">{errors.otp.message}</span>}
          </div>
        )}

        <div className="input_wrapper" style={{ position: "relative" }}>
          <input
            type="text"
            id="InstituteName"
            placeholder="Enter Institute Name"
            autoComplete="off"
            className="dropdown-field"
            {...register("InstituteName", {
              required: "Institute Name is required",
            })}
            onFocus={(e) => {
              handleFieldFocus("InstituteName");
              handleFocus?.(e);
            }}
            onInput={handleInput}
            onBlur={(e) => {
              register("InstituteName").onBlur(e);

              const value = e.target.value.trim();

              setTimeout(() => {
                setShowList(false);
                if (value && !institutesLower.includes(value.toLowerCase())) {
                  setValue("InstituteName", "Others", {
                    shouldValidate: true,
                  });
                }
              }, 150);
            }}
          />
          <div className="dropdown-arrow hideArrow">
            <img src="dist/img/down.svg" alt="" width={15} />
          </div>

          {showList && filteredInstitutes.length > 0 && (
            <ul
              className="autocomplete-list"
              onMouseLeave={() => setShowList(false)} // ✅ FIX
            >
              {filteredInstitutes.map((name, index) => (
                <li
                  key={index}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleInstituteSelect(name);
                    // const upper = name;
                    // document.getElementById("InstituteName").value = upper;
                    // setValue("InstituteName", upper, {
                    //   shouldValidate: true,
                    //   shouldTouch: true,
                    // });

                    // setShowList(false);
                  }}
                >
                  {name}
                </li>
              ))}
            </ul>
          )}

          {errors.InstituteName && (
            <span className="error">{errors.InstituteName.message}</span>
          )}
        </div>

        {!isOthersSelected && (
          <>
            <div className="input_wrapper" style={{ position: "relative" }}>
              <input
                type="text"
                id="YearPassing"
                placeholder="Year of Passing"
                autoComplete="off"
                className="dropdown-field"
                maxLength={4}
                {...register("YearPassing", {
                  required: "Year of passing is required",
                  validate: (value) => {
                    if (!value) return true;

                    const year = Number(value);
                    if (isNaN(year)) return "Enter a valid year";

                    if (year < 1980 || year > 2025) {
                      return "Year must be between 1980 and 2025";
                    }

                    return true;
                  },
                })}
                onFocus={handleFocus1}
                onBlur={(e) => {
                  register("YearPassing").onBlur(e);
                  handleBlur1();
                }}
                onInput={handleInput1}
              />
              <div className="dropdown-arrow">
                <img src="dist/img/down.svg" alt="" width={15} />
              </div>

              {showList1 && (
                <ul className="autocomplete-list">
                  {filteredYears.map((year) => (
                    <li key={year} onMouseDown={() => handleSelect1(year)}>
                      {year}
                    </li>
                  ))}
                </ul>
              )}

              {errors.YearPassing && (
                <span className="error">{errors.YearPassing.message}</span>
              )}
            </div>
          </>
        )}

        {isOthersSelected && (
          <>
            <div className="position-relative input_wrapper">
              <select
                id="occupation"
                {...register("employmentType", {
                  required: "Select your profession",
                })}
                defaultValue=""
                onFocus={() => handleFieldFocus("employment type")}
                className={`custom-dropdown black-dropdown ${employmentType ? "filled" : "placeholder"
                  }`}
              >
                <option value="" disabled>
                  Profession
                </option>
                <option value="salaried">Salaried</option>
                <option value="self-employed">Self Employed</option>
              </select>
              <img
                src="dist/img/icons/down.svg"
                className="arrow"
                width="18"
                alt="arrow"
              />
              {errors.employmentType && (
                <span className="error">{errors.employmentType.message}</span>
              )}
            </div>

            {employmentType === "self-employed" && (
              <>
                <div className="position-relative input_wrapper">
                  <input
                    type="text"
                    id="lastYearIncome"
                    onFocus={() => handleFieldFocus("lastYearIncome")}
                    placeholder="Enter your last year's annual income"
                    inputMode="numeric"
                    {...register("lastYearIncome", {
                      required: "Annual income is required",
                      pattern: {
                        value: /^[0-9,]*$/, // allow commas and empty
                        message: "Only numbers are allowed",
                      },
                      setValueAs: (value) => {
                        if (!value) return "";
                        return value.replace(/,/g, "");
                      },
                      onChange: (e) => {
                        const raw = e.target.value.replace(/\D/g, "");
                        const formatted = raw.replace(
                          /(\d)(?=(\d{2})+\d$)/g,
                          "$1,"
                        );
                        e.target.value = formatted;
                      },
                      onBlur: (e) => { },
                    })}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      if (
                        !/[0-9]/.test(e.key) &&
                        !allowedKeys.includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.lastYearIncome && (
                    <span className="error">
                      {errors.lastYearIncome.message}
                    </span>
                  )}
                </div>

                <div className="position-relative input_wrapper">
                  <select
                    id="itr"
                    {...register("hasITR", {
                      required: "Select ITR option",
                    })}
                    onFocus={() => handleFieldFocus("hasITR")}
                    defaultValue=""
                    // className={hasITR ? "filled" : "placeholder"}
                    className={`custom-dropdown black-dropdown ${hasITR ? "filled" : "placeholder"
                      }`}
                  >
                    <option value="" disabled>
                      Do you have last year's ITR
                    </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                  <img
                    src="dist/img/icons/down.svg"
                    className="arrow"
                    width="18"
                    alt="arrow"
                  />
                  {errors.hasITR && (
                    <span className="error">{errors.hasITR.message}</span>
                  )}
                </div>
              </>
            )}

            {employmentType === "salaried" && (
              <>
                <div
                  className="position-relative input_wrapper"
                  ref={companyWrapperRef}
                >
                  {/* <input
                    className="input-box"
                    type="text"
                    placeholder="Enter Company"
                    autoComplete="off"
                    value={localCompanyInput}
                    onFocus={(e) => {
                      handleFieldFocus("company");
                      handleLocalCompanyFocus(e); // 👈 show list on focus
                    }}
                    {...register("companyName", {
                      required: "This field is required",
                      onChange: (e) => {
                        handleLocalCompanyChange(e); // 👈 filter list
                        setShowOtherCompanyInput(false);
                      },
                    })}
                  /> */}

                  {/* Dropdown */}
                  {/* {localCompanyList.length > 0 && (
                    <ul className="companydropDown">
                      {localCompanyList.map((item) => (
                        <li
                          key={item.name}
                          className="company-List"
                          onMouseDown={(e) => {
                            e.preventDefault();

                            if (item.name === "Others") {
                              setShowOtherCompanyInput(true);
                              setLocalCompanyInput("Others");
                            } else {
                              setLocalCompanyInput(item.name);
                            }

                            setValue("companyName", item.name, {
                              shouldValidate: true,
                              shouldTouch: true,
                            });

                            setLocalCompanyList([]);
                          }}
                        >
                          {item.name}
                        </li>
                      ))}
                    </ul>
                  )} */}

                  <input
                    className="input-box"
                    type="text"
                    name="company"
                    // onFocus={() => handleLastFieldFocus("company")}
                    value={companyName}
                    placeholder="Enter Company"
                    autoComplete="off"
                    onFocus={() => handleFieldFocus("Company")}
                    {...register("companyName", {
                      required: "This field is required.",
                      onChange: (e) => {
                        const inputVal = e.target.value;
                        setCompanyName(inputVal);
                        onCompanyChange(e); // Your filter logic
                        setShowOtherInput(false); // Hide other input if typing again
                      },
                    })}
                  />

                  {/* Company dropdown */}
                  {companies.length ? (
                    <div className="company-selection-container">
                      <ul className="companydropDown">
                        {companies.map((item) => (
                          <li
                            className="company-List"
                            key={item.Entity_Name}
                            onClick={() => {
                              setCompanyName(item.Entity_Name);
                              setValue("companyName", item.Entity_Name);

                              if (item.Entity_Name === "Others") {
                                setShowOtherInput(true);
                                // settopCorporate("others");
                                setValue("topCorporate", "others");
                              } else {
                                // settopCorporate(item.Top_Corporate); // "yes" / "no"
                                setValue("topCorporate", item.Top_Corporate);
                              }

                              setCompanies([]);
                            }}
                          >
                            {item.Entity_Name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                  {errors.companyName && (
                    <span className="error">{errors.companyName.message}</span>
                  )}
                </div>

                <div className="position-relative input_wrapper">
                  <select
                    id="annualincome"
                    {...register("annualIncome", {
                      required: "Select annual income",
                    })}
                    onFocus={() => handleFieldFocus("annualIncome")}
                    defaultValue=""
                    className={`custom-dropdown black-dropdown ${annualIncome ? "filled" : "placeholder"
                      }`}
                  >
                    <option value="" disabled>
                      Annual Income
                    </option>
                    <option value="below 2,40,000">below ₹2,40,000</option>
                    <option value="2,40,000 - 5,99,999">
                      ₹2,40,000 - ₹5,99,999
                    </option>
                    <option value="6,00,000 - 8,99,999">
                      ₹6,00,000 - ₹8,99,999
                    </option>
                    <option value="9,00,000 - 17,99,999">
                      ₹9,00,000 - ₹17,99,999
                    </option>
                    <option value="18,00,000 - 47,99,999">
                      ₹18,00,000 - ₹47,99,999
                    </option>
                    <option value="48,00,000 - 2,49,99,999">
                      ₹48,00,000- ₹2,49,99,999
                    </option>
                    <option value="2,50,00,000 and above">
                      ₹2,50,00,000 and above
                    </option>
                  </select>
                  <img
                    src="dist/img/icons/down.svg"
                    className="arrow"
                    width="18"
                    alt="arrow"
                  />
                  {errors.annualIncome && (
                    <span className="error">{errors.annualIncome.message}</span>
                  )}
                </div>
              </>
            )}
          </>
        )}

        <div className="input_wrapper">
          <input
            type="text"
            id="pan"
            placeholder="PAN Number"
            maxLength={10}
            inputMode="text"
            {...register("pan", {
              required: "PAN number is required",
              pattern: {
                value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                message: "Invalid PAN format",
              },
            })}
            onFocus={() => handleFieldFocus("pan")}
            onInput={(e) => {
              handleChange(e);

              let value = e.target.value.toUpperCase();

              if (value.length < 5) {
                // Only alphabets
                value = value.replace(/[^A-Z]/g, "");
                e.target.inputMode = "text";
              } else if (value.length < 9) {
                // Next 4 digits
                value =
                  value.slice(0, 5) + value.slice(5).replace(/[^0-9]/g, "");
                e.target.inputMode = "numeric";
              } else {
                // Last alphabet
                value =
                  value.slice(0, 9) + value.slice(9).replace(/[^A-Z]/g, "");
                e.target.inputMode = "text";
              }

              e.target.value = value;
            }}
          />

          {errors.pan && <span className="error">{errors.pan.message}</span>}
        </div>

        {/* <button
          type="button"
          className="reset"
          id="resetBtn"
          onClick={handleReset}
        >
          Reset Details
        </button> */}
        <div
          className="position-relative input_wrapper d-flex align-items-start justify-content-center mt-3 agreetncwrap"
          style={{ gap: "10px" }}
        >
          <Controller
            name="agreetnc"
            control={control}
            defaultValue={false}
            rules={{
              validate: (value) =>
                value === true ||
                "Please agree to our Terms & Conditions to proceed.",
            }}
            render={({ field }) => (
              <input
                type="checkbox"
                id="agreetnc"
                style={{ width: "fit-content" }}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            )}
          />

          <label className="terms" htmlFor="agreetnc">
            I agree to ICICI Bank's{" "}
            <a
              href="https://www.icicibank.com/personal-banking/cards/credit-card/documents"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => Tandc()}
            >
              Terms & Conditions
            </a>{" "}
            and{" "}
            <a
              href="https://www.icicibank.com/managed-assets/docs/personal/cards/MITC_cc.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => MITandC()}
            >
              Most Important Terms & Conditions
            </a>{" "}
          </label>
        </div>
        {errors.agreetnc && (
          <span className="error">{errors.agreetnc.message}</span>
        )}
        <button
          id="proceed"
          type="submit"
          className={`proceed ${!isValid ? "disabled" : ""}`}
          //disabled={!isValid}
          disabled={disableApplyBtn}
          style={{ backgroundColor: disableApplyBtn ? "grey" : "" }}
        >
          {disableApplyBtn ? "Submitting..." : "Apply Now"}{" "}
        </button>

        <div className="toast-container" id="toastContainer"></div>

        {/* {otpVerified && isValid && (
        <button id="proceed" type="submit" className="proceed">
          Proceed
        </button>)} */}
      </div>
    </form>
  );
}

export default FormComponent;
